module.exports = __webpack_public_path__ + "img/quotes-background.e91036c0.jpg";